import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppState } from '~/reducers';
import { useLazyGetRoboticMowersMissionsProgressQuery } from '../api/robotic-mowers-api';
import { updateRoboticMowersMissionsProgress } from '../store/actions';

const useRoboticMowersMissionsProgressTracker = () => {
  const [requestId, setRequestId] = useState<number | undefined>();
  const dispatch = useDispatch();
  const { footprintsChangedTimestamp: criteria } = useSelector(
    (state: AppState) => state.roboticMowers
  );

  const [trigger, { data: updatedMissions, isFetching: isLoadingMissions }] =
    useLazyGetRoboticMowersMissionsProgressQuery();

  useEffect(() => {
    // When criteria changes, reset previous request
    setRequestId(undefined);
  }, [criteria]);

  useEffect(() => {
    if (criteria && !isLoadingMissions && requestId !== criteria) {
      trigger();
      setRequestId(criteria);
    }
  }, [isLoadingMissions, criteria, trigger, requestId]);

  useEffect(() => {
    if (updatedMissions !== undefined && updatedMissions.items.length > 0) {
      dispatch(updateRoboticMowersMissionsProgress({ items: updatedMissions.items }));
    }
  }, [dispatch, updatedMissions]);
};

export { useRoboticMowersMissionsProgressTracker };
